<div class="flex flex-col gap-(--gap-tight)">
  <label for="suspend-start" class="font-medium text-sm">
    {{ 'entities.measureFormula.messages.suspendStart' | transloco }}
  </label>
  <p-datePicker
    inputId="suspend-start"
    [ngModel]="startDate()"
    (ngModelChange)="onStartDateChange($event)"
    [showTime]="true"
    [showIcon]="true"
    iconDisplay="input"
    [showOnFocus]="true"
    dateFormat="dd.mm.yy"
    appendTo="body"
    [defaultDate]="startDefaultDate()"
    [placeholder]="startPlaceholderKey | transloco"
    styleClass="w-full" />
  <small class="text-xs text-(color:--text-secondary)">
    {{ startHintKey | transloco }}
  </small>
</div>

<div class="flex flex-col gap-(--gap-tight) mt-(--space-3)">
  <label for="suspend-end" class="font-medium text-sm">
    {{ 'entities.measureFormula.messages.suspendEnd' | transloco }}
  </label>
  <!-- UAT 27.07 #4 : pas de minDate ; une date tapée avant le début doit atteindre le modèle
       pour que suspendEndBeforeStart s'affiche, sinon le picker la rejette en silence. -->
  <p-datePicker
    inputId="suspend-end"
    [ngModel]="endDate()"
    (ngModelChange)="onEndDateChange($event)"
    [showTime]="true"
    [showIcon]="true"
    iconDisplay="input"
    [showOnFocus]="true"
    dateFormat="dd.mm.yy"
    appendTo="body"
    [defaultDate]="endDefaultDate()"
    [placeholder]="'entities.measureFormula.messages.suspendEndPlaceholder' | transloco"
    styleClass="w-full" />
  <small class="text-xs text-(color:--text-secondary)">
    {{ 'entities.measureFormula.messages.suspendEndHint' | transloco }}
  </small>
</div>

<div class="flex flex-col gap-(--gap-tight) mt-(--space-3)">
  <label for="suspend-comment" class="font-medium text-sm">
    {{ 'entities.measureFormula.messages.suspendComment' | transloco }}
  </label>
  <textarea
    pTextarea
    id="suspend-comment"
    rows="3"
    [autoResize]="true"
    [ngModel]="comment()"
    (ngModelChange)="onCommentChange($event)"
    [placeholder]="'entities.measureFormula.messages.suspendCommentPlaceholder' | transloco"
    [maxlength]="maxCommentLength"
    [attr.aria-describedby]="visibleError() ? 'suspend-error' : null"
    class="w-full"></textarea>
  <div class="flex justify-between text-xs text-(color:--text-secondary)">
    <span>{{ 'entities.measureFormula.messages.suspendCommentHint' | transloco }}</span>
    <span>{{ commentLength() }} / {{ maxCommentLength }}</span>
  </div>
</div>

@if (visibleError(); as err) {
  <small id="suspend-error" class="text-(color:--p-red-500) mt-(--space-2) block" role="alert">{{
    err.key | transloco: err.params
  }}</small>
}

<ces-dialog-footer
  [submitLabel]="(mode === 'edit' ? 'common.buttons.save' : 'entities.measureFormula.messages.suspend') | transloco"
  [cancelDisabled]="submitting() || deleting()"
  [submitDisabled]="!!clientValidationError() || submitting() || deleting()"
  (onCancel)="cancel()"
  (onSubmit)="confirm()">
  @if (mode === 'edit') {
    <ces-delete-button
      footer-start
      [label]="'entities.measureFormula.messages.deleteSuspensionAction' | transloco"
      [confirmationConfig]="deleteConfirmationConfig()"
      (confirm)="onDeleteConfirmed()" />
  }
</ces-dialog-footer>
